import "./App.css";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Routing from "./router/Routing";
function App() {
  return (
    <>
      <Routing />
    </>
  );
}

export default App;
